import React from "react";
import getComponentFromLookup from "../../../helpers/logic/get-component-from-lookup";
import IMAGE_COMPONENT_MAP from "./constants";
import { BaseEmptyStateImage } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function EmptyStateImage(_ref) {
  var image = _ref.image;
  var mappedImage = getComponentFromLookup(IMAGE_COMPONENT_MAP, image, "folder", null);
  return /*#__PURE__*/_jsx(BaseEmptyStateImage, {
    children: mappedImage
  });
}
export default EmptyStateImage;